export default {
  name: "HasError",
  bind: resolve,
  componentUpdated: resolve
};

function resolve(element, { value }) {
  if (hasError(value)) {
    addHasError(element);
  } else {
    removeHasError(element);
  }
}

function hasError(value) {
  return value.$anyError && value.$dirty;
}

function addHasError(element) {
  element.classList.add("has-error");
}

function removeHasError(element) {
  element.classList.remove("has-error");
}
